export default __webpack_public_path__ + "static/media/icon-pinterest.45264b1d.svg";